import { StoreDetailResponse, StoreInfo, StoreSettings } from '@/types/pages/stores';

export type SetSettingsRequest = Partial<StoreSettings>;

export interface ExceptionSettings {
    parameter: string;
    reason: string;
}
export interface SetSettingsResponse {
    processed_to_db: boolean;
    invalid_settings: string[];
    valid_settings: { name: string; value: string }[];
    exception_settings: ExceptionSettings[];
}
export type FieldOption = { fieldnum: number; key: string; name: string };
export interface StoreSettingsState {
    isLoading: boolean;
    storeInfo: Partial<StoreInfo>;
    settings: Partial<
        StoreSettings & {
            pp2w_trigger_fields: number[];
        }
    >;
    originalSettings: Partial<StoreSettings>;
    customFieldOptions: FieldOption[];
    priorityOptions: string[];
    validationErrors: ExceptionSettings[];
    assetList: string[];
    storeId: number | null;
}

export type StoreSettingsAction =
    | { type: 'SET_LOADING'; payload: boolean }
    | { type: 'SET_STORE_INFO'; payload: StoreInfo }
    | { type: 'SET_STORE_ASSET_LIST'; payload: string[] }
    | { type: 'SET_SETTINGS'; payload: Partial<StoreSettings> }
    | { type: 'SET_CUSTOM_FIELD_OPTION'; payload: FieldOption[] }
    | { type: 'SET_PRIORITIZE_OPTIONS'; payload: string[] }
    | { type: 'SET_ORIGINAL_SETTINGS'; payload: Partial<StoreSettings> }
    | { type: 'SET_STORE_ID_AND_SETTINGS'; payload: StoreDetailResponse }
    | { type: 'SET_VALIDATION_ERRORS'; payload: ExceptionSettings[] };

export const AURA_PRIMARY_FIELD_OPTION: FieldOption[] = [
    { fieldnum: 1, key: 'field.product_number', name: 'Product Number' },
    { fieldnum: 3, key: 'field.layout_index', name: 'Layout Index' },
    { fieldnum: 4, key: 'field.product_name', name: 'Product Name' },
    { fieldnum: 5, key: 'field.area', name: 'Area' },
    { fieldnum: 6, key: 'field.unit', name: 'Unit' },
    { fieldnum: 7, key: 'field.price', name: 'Price' },
    { fieldnum: 8, key: 'field.promo_price', name: 'Promo Price' },
];
